export const LINE_BROADCAST_COOLDOWN_MS = 60 * 1000

const STORAGE_KEY_PREFIX = 'dentco:line-broadcast:cooldown:v1'
const MAX_CLOCK_SKEW_MS = 5 * 1000

function getStorage(storage) {
  if (storage) return storage

  try {
    return typeof window === 'undefined' ? null : window.localStorage
  } catch (error) {
    return null
  }
}

export function buildLineBroadcastCooldownKey(auth = {}) {
  const accountType = String(auth.type || '')
  if (!['1', '2'].includes(accountType)) return null

  const accountCode = accountType === '1' ? auth.clinic_code : auth.doctor_code
  const crmUser = auth.crm_user_id || auth.crm_user_account
  if (!accountCode || !crmUser) return null

  const identity = [accountType, accountCode, crmUser]
    .map(value => encodeURIComponent(String(value)))
    .join(':')

  return `${STORAGE_KEY_PREFIX}:${identity}`
}

export function getCooldownRemainingSeconds(expiresAt, now = Date.now()) {
  const normalizedExpiresAt = Number(expiresAt)
  if (!Number.isFinite(normalizedExpiresAt) || normalizedExpiresAt <= now) return 0

  return Math.ceil((normalizedExpiresAt - now) / 1000)
}

export function readLineBroadcastCooldown(key, now = Date.now(), storageSource) {
  const storage = getStorage(storageSource)
  if (!key || !storage) return 0

  try {
    const expiresAt = Number(storage.getItem(key))
    const isTooFarInFuture = expiresAt > now + LINE_BROADCAST_COOLDOWN_MS + MAX_CLOCK_SKEW_MS
    if (!Number.isFinite(expiresAt) || expiresAt <= now || isTooFarInFuture) {
      return 0
    }
    return expiresAt
  } catch (error) {
    return 0
  }
}

export function writeLineBroadcastCooldown(key, expiresAt, storageSource) {
  const storage = getStorage(storageSource)
  if (!key || !storage || !Number.isFinite(Number(expiresAt))) return false

  try {
    storage.setItem(key, String(expiresAt))
    return true
  } catch (error) {
    return false
  }
}

export function clearLineBroadcastCooldown(key, storageSource) {
  const storage = getStorage(storageSource)
  if (!key || !storage) return false

  try {
    storage.removeItem(key)
    return true
  } catch (error) {
    // localStorage 不可用時保留元件內防護，不中斷使用者流程
    return false
  }
}
